import axios from 'axios'
import { Message } from 'element-ui'
const rsa = require('./rsa');
import router from '@/router'

// 创建axios实例
const service = axios.create({
    baseURL: '/jbl/api', // 移除多余的引号
    timeout: 3600000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }
        if (localStorage.getItem('_token')) {
            config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('_token')).token}`
        }
        let language = 'zh_CN'
        if (localStorage.getItem('language')) {
            language = localStorage.getItem('language')
        }
        config.headers['Language'] = language;
        if (config.method === 'post' || config.method === 'put') {
            config.headers['Content-Sign'] = rsa.default.dataMd5Encry(JSON.stringify(config.data));
        }
        return config
    },
    error => {
        // 对请求错误做些什么
        console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        return res;
    },
    error => {
        let errorMessage;
        if (error.status === 602) {
            if (error.response.data && error.response.data[0]) {
                errorMessage = error.response.data[0].message;
            }
        } else if (error.status === 401) {
            if (localStorage.getItem('_token')) {
                localStorage.removeItem('_token');
                localStorage.removeItem('user');
                localStorage.removeItem('currentPerson');
            }
            router.push('/login');
        } else if (error.status === 403) {
            errorMessage = 'NO Authorization'
        } else if (error.msg) {
            errorMessage = error.msg;
        } else if (error.message) {
            errorMessage = error.message;
        }
        if (errorMessage) {
            Message({
                message: errorMessage,
                type: 'error',
                duration: 3000
            })
        }
        return Promise.reject(error)
    }
)

export default service